import { styled, css } from 'styled-components';
import { getFontSize, getFontWeight } from '../../../abstracts/typography';
import { createTransition } from '../../../util';
import { TextareaContainer } from './TextareaContainer';
const inputStateToCss = {
  success: css(["color:var(--aui-status-success);"]),
  warn: css(["color:var(--aui-on-surface);"]),
  error: css(["color:var(--aui-status-error);"]),
  default: css(["color:var(--aui-on-surface-soft);", ":hover &,", ":active &,", ".has-focus &{color:var(--aui-on-surface);}"], TextareaContainer, TextareaContainer, TextareaContainer)
};
export const TextareaLabel = styled.label.withConfig({
  componentId: "aui__sc-1n52o1e-0"
})(["position:relative;pointer-events:none;display:block;top:0;left:0;right:0;font-size:", ";-moz-osx-font-smoothing:grayscale;font-weight:", ";line-height:1.25rem;padding-bottom:0;padding-left:0.75rem;padding-top:0.75rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin:0;border-radius:0.375rem 0.375rem 0 0;", ";", " &:has(~ textarea:focus){font-size:", ";}", " &:has(~ textarea:disabled){color:var(--aui-on-surface-soft);opacity:var(--aui-state-layer-on-disabled);}"], getFontSize(2), getFontWeight('base'), ({
  $fieldStatus
}) => inputStateToCss[$fieldStatus], ({
  $hasContent
}) => $hasContent && `font-size: ${getFontSize(1)};`, getFontSize(1), createTransition({
  properties: ['font-size', 'color']
}));